
import { defineComponent } from 'vue'
export default defineComponent({
  emits: ['click'],
  name: 'Button2',
  props: {
    isActive: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  setup(props, { emit }) {
    return {}
  }
})
